<template>
  <main>
    <section class="fk-contents">
      <h2 class="title-lv2 mb20">{{text.Heading}}</h2>
      <div class="mod-selected-store" v-if="model.visibleLastStore">
        <span class="label">{{text.LastUse}}</span>
        <div class="mod-selected-store-wrap has-btn-select">
          <div class="mod-selected-store-name">
            <img :src="lastSelectStore.image" :alt="lastSelectStore.store_name"><span class="name">{{lastSelectStore.store_name}}</span>
          </div>
          <div class="mod-selected-store-btn" v-if="!lastSelectStore.is_closed"><input type="button" :value="text.Select" class="btn-base btn-sub" @click="execSelectLastStore()"></div>
        </div>
      </div>
      <p class="mod-form-btn"><input type="button" :value="text.SurroundingStore" class="btn-base btn-sub" @click="execSelectLocation()"></p>

      <div class="mod-select-area">
        <div class="mod-form-block">
          <span class="label">{{$t('ShopSearch.SelectArea')}}</span>
          <select name="" id="" v-model="model.selected.area_cd">
            <option value="">{{text.AreaSearch}}</option>
            <option v-for="(area, index) in areaList" :key="index" :value="area.area_cd">{{area.area_name}}</option>
          </select>
        </div>
        <p class="mod-form-btn"><input type="button" :value="text.SelectAbove" class="btn-base btn-sub" @click="execSelectArea()"></p>
      </div>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import ValidationMixin from '@/mixins/ValidationMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
import GeolocationMixin from '@/mixins/GeolocationMixin'
import StoreUtilMixin from '@/mixins/StoreUtilMixin'
import { get } from 'lodash'
export default {
  name: 'FKMOStoreSelect',
  mixins: [ CommonMixin, ValidationMixin, DisplayErrorMixin, GeolocationMixin, StoreUtilMixin ],
  data () {
    return {
      isLogin: false,
      areaList: [],
      lastSelectStore: {
        store_cd: null,
        store_name: null,
        image: null,
        is_closed: false
      },
      text: {
        Heading: null,
        LastUse: null,
        Select: null,
        SurroundingStore: null,
        AreaSearch: null,
        SelectAbove: null
      },
      model: {
        selected: {
          area_cd: ''
        },
        visibleLastStore: false
      }
    }
  },
  computed: {
    getDisabledButton () {
      return this.$store.getters.disabledButton
    },
    getSelectStore () {
      return this.$store.getters.selectStore
    }
  },
  methods: {
    loginCheck: function () {
      if (sessionStorage.getItem('login') !== null) {
        return true
      }
      return false
    },
    execSelectLastStore: function () {
      if (this.getDisabledButton) {
        return false
      }
      if (this.isLogin) {
        let store = JSON.parse(sessionStorage.getItem('login')).last_store

        this.checkStoreCode(store.store_cd)

        // 表示データを生成する
        const outputs = this.makeDisplayInfo(store)
        store = Object.assign(store, outputs)
        this.$store.commit('setSelectStore', store)

        // 営業時間中判定
        this.setIsSales(this.$parent.fkmoTimer, store)
        // 営業時間帯判定
        this.setIsAcceptingMenu(this.$parent.fkmoTimer, store)
        // メニューカテゴリー種別を設定
        this.setMenuCategoryType()

        this.$router.push({ name: 'ReceiveMethod' })
      }
    },
    execSelectLocation: function () {
      if (this.getDisabledButton) {
        return false
      }
      this.$store.dispatch('setDisabledButton', true)

      const _that = this
      this.getGeolocation()
        .then(function (res) {
          _that.$store.dispatch('setStoreSearchParams', {
            latitude: res.lat,
            longitude: res.lng,
            area_cd: null,
            type: 1
          })
          _that.$router.push({ name: 'StoreList' })
        })
        .finally(() => {
          this.$store.dispatch('setDisabledButton', false)
        })
    },
    execSelectArea: function () {
      if (this.getDisabledButton) {
        return false
      }
      this.$store.dispatch('setDisabledButton', true)

      // 未選択の時は遷移させない
      if (this.model.selected.area_cd === '') {
        this.$store.dispatch('setDisabledButton', false)
        window.commonAlert(this.$i18n.t('ErrorMsg.ERR_031'))
        return false
      }

      this.$store.dispatch('setStoreSearchParams', {
        latitude: null,
        longitude: null,
        area_cd: String(this.model.selected.area_cd),
        type: 2
      })
      this.$router.push({ name: 'StoreList' })
      this.$store.dispatch('setDisabledButton', false)
    },
    getAreaList: function () {
      const _that = this

      this.callApi('AreaList',
        {
          language: sessionStorage.getItem('lang')
        }
      )
      // this.axios.get('/static/stub/StoreSelect/arealist.json')
        .then(function (res) {
          if (res.data.result) {
            _that.areaList = res.data.value.area_list
          } else {
            _that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch(function (error) {
          _that.errorFromAxios(error)
        })
    },
    init: function () {
      const _that = this
      this.isLogin = this.loginCheck()

      // 前回ご利用いただいた店舗を表示
      let store = [] // NOTE 前回ご利用いただいた店舗がない場合は空配列が返されるので、それに合わせて初期化する
      if (this.isLogin) {
        store = JSON.parse(sessionStorage.getItem('login')).last_store

        // オブジェクトで返さたキーの個数を数えて、0より大きければ「前回ご利用いただいた店舗」のオブジェクトが返されていると判断する
        if (Object.keys(store).length > 0) {
          // 店舗情報取得API叩く
          this.callApi('StoreInfo',
            {
              store_cd: store.store_cd,
              language: sessionStorage.getItem('lang')
            }
          ).then((res) => {
            const storeInfo = get(res, 'data.value.store_info', null)
            if (res.data.result && storeInfo != null) {
              this.lastSelectStore = {
                store_cd: storeInfo.store_cd,
                store_name: storeInfo.store_name,
                image: storeInfo.image_url,
                is_closed: storeInfo.is_closed
              }
            }
          }).catch((error) => {
            _that.errorFromAxios(error)
          })

          this.model.visibleLastStore = true
        }
      }

      // 検索用パラメータをリセットする
      this.$store.dispatch('setStoreSearchParams', {
        latitude: null,
        longitude: null,
        area_cd: null
      })

      this.getAreaList()
    },
    initView: function () {
      // マウント後に画面出力する文字列を設定する
      this.text.Heading = this.$i18n.t('ShopSearch.Heading')
      this.text.LastUse = this.$i18n.t('ShopSearch.LastUse')
      this.text.Select = this.$i18n.t('General.Select')
      this.text.SurroundingStore = this.$i18n.t('ShopSearch.SurroundingStore')
      this.text.AreaSearch = this.$i18n.t('ShopSearch.AreaSearch')
      this.text.SelectAbove = this.$i18n.t('ShopSearch.SelectAbove')
    }
  },
  beforeMount () {
    this.init()
  },
  mounted () {
    this.initView()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>

<style scoped>
input[type=button] {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreSelect.vue